import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import Alert from "react-bootstrap/Alert";
import Modal from "react-modal";
import { Container, Row, Col } from "react-bootstrap";
import Notifications from "../push-notifications/Notifications";
import WelcomeUser from "../Open-pages/user/WelcomeUser";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../common-components/CommonStructured";
import { fetchUpgradeMembershipsData } from "../../redux/plans-reducers/plansSlice";
import UMListings from "./UMListings";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
// import PartialDetails from "./PartialDetails";
import UMForm from "./UMForm";
import CmnFilters from "../lead-management/common/CmnFilters";
import OnlineCashCollect from "../payment-link-system/partial-payment/online-cash-partial-payments/OnlineCashCollect";

const UMLanding = ({
  userInfoData,
  isCustom,
  isIOS,
  // isNotificationDenied
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { upgradeMembershipsLoading } = useSelector((state) => state.plans);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
    partialDetails: [],
  };
  const [modValues, setModValues] = useState(iniModvalues);
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selAddedby: !isAdmin && !isManagerRole
      ? {
          label: userInfoData?.name || "",
          value: userInfoData?.uid || userInfoData?.user_id || "",
        }
      : "",
    isActive: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    upgraded_by: allFilters.selAddedby?.value || "",
    current_subscription_status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const handleBack = (e) => {
    e.preventDefault();

    navigate("/open-access/all-pages", {
      state: { userInfo: userInfoData, decryptedText: userInfoData },
    });
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getUMLists(filters) {
    dispatch(
      fetchUpgradeMembershipsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: !isAdmin
  //       ? {
  //           label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //           value:
  //             userInfoData?.gym_id ||
  //             userInfoData?.user_id ||
  //             userInfoData?.uid ||
  //             "",
  //         }
  //       : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      upgraded_by: allFilters.selAddedby?.value || "",
      current_subscription_status: allFilters.isActive?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selAddedby,
    allFilters.isActive,
  ]);

  useEffect(() => {
    getUMLists(filters);
  }, [filters]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Upgrade Membership">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        {isCustom && (
          <div className="mt30">
            <WelcomeUser userName={userInfoData?.name} />

            {userInfoData && !isIOS() && (
              <Notifications authData={userInfoData} />
            )}

            {/* {isNotificationDenied === "denied" && (
              <Alert variant={"danger"} className="mt30">
                Notification permission is denied. Unable to display desktop
                notifications.
              </Alert>
            )} */}
          </div>
        )}

        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Details Modal"
          ariaHideApp={false}
        >
          <div className={`createNewCTOModalContainer`}>
            {modValues.cardName === "add" ? (
              <UMForm
                userInfoData={userInfoData}
                callFunction={() => getUMLists(filters)}
                closeModal={onCloseModal}
              />
            ) : (
              <>
                <ModalHeadAndClose
                  title={modValues.cardName?.replace(/_/g, " ")}
                  onClose={onCloseModal}
                />

                {modValues.cardName === "partial_details" ? (
                  <>
                    <OnlineCashCollect
                      tbData={modValues.partialDetails}
                      userInfoData={userInfoData}
                      callFunction={() => {
                        getUMLists(filters);
                        onCloseModal();
                      }}
                      cashSuccessMessage="Cash draft created"
                    />
                    {/* <PartialDetails tbData={modValues.partialDetails} /> */}
                  </>
                ) : null}
              </>
            )}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Upgrade Membership"}
              createBtnTxt={"+ Add New"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
              isReload={() => {
                getUMLists(filters);
              }}
              onClickBackBtn={isCustom ? handleBack : null}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <CmnFilters
              from={"um"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={upgradeMembershipsLoading}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <UMListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default UMLanding;
